'use strict';

import PropTypes from 'prop-types';
import React from 'react';
import { trackCustomEvent } from '../../../../utils/statistics/clientStatistics';
import { mainMenuItemClickEvent } from '../../../../utils/statistics/customEvents';
import { Link, ListItem } from './MenuItem.styles';
import PlayText, { TYPES } from '../../../../ui-components/typography/PlayText/PlayText';
import { regularWhite } from '../../../../ui-components/design-tokens';

export const MenuItem = ({ route, accessKey, type, text, isIndexLink, index }) => (
    <ListItem type={type} data-rt="menu-item">
        <Link
            to={route}
            activeClassName="play_is-active"
            isIndexLink={isIndexLink}
            accessKey={accessKey}
            onAfterClick={() => {
                trackCustomEvent(mainMenuItemClickEvent(text, index));
            }}
        >
            <PlayText as="span" type={TYPES.SMALL} color={regularWhite}>
                {text}
            </PlayText>
        </Link>
    </ListItem>
);

MenuItem.propTypes = {
    route: PropTypes.string.isRequired,
    accessKey: PropTypes.string.isRequired,
    type: PropTypes.string,
    text: PropTypes.string.isRequired,
    isIndexLink: PropTypes.bool,
    index: PropTypes.number,
};

export default MenuItem;
